<template>
    <div class="top-content">
        <img src="@/assets/img/img10.png" class="icon" @click="goBack()"></img>
        <div class="title">{{ title }}</div>
        <i class="el-icon-s-home home" @click="goHome"></i>
    </div>
</template>
<script>
export default {
    props: ['title'],
    data() {
        return {};
    },
    methods: {
        goBack() {
            this.$router.back(-1)
        },
        goHome(){
            this.$router.push('/')
        }
    }
};
</script>
<style lang="scss" scoped>
.top-content {
    padding: 32px 35px;
    position: relative;
    margin-bottom: 20px;
    .icon {
        width: 11px;
        height: 18px;
        z-index: 1000;position: absolute;
    }

    .title {
        position: absolute;
        width: calc(100% - 92px);
        top: 32px;
        left: 35px;
        text-align: center;
        font-size: 16px;
        font-weight: bold;
        color: #000;
        z-index: 1;
    }
    .home{
        position: absolute;
        top: 32px;
        right: 35px;
        font-size: 20px;
    }
}
</style>
